import { setAll } from "../helpers";
import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IBaseAddressAsyncThunk } from "./interfaces";
import { addresses } from "../configs/constants";
import { abi as TokenVestingABI } from "../abis/TokenVesting_EDE.json";
import { ethers } from "ethers";
import { PLACEHOLDER_ACCOUNT } from "src/helpers/Helpers";

export const loadVestingDetails = createAsyncThunk(
  "vesting/loadVesting",
  async ({ networkID, provider, address }: IBaseAddressAsyncThunk) => {
    console.log("loadVestingDetails");
    const signer = provider.getSigner();

    const TokenVestingContract_EDE = new ethers.Contract(
      addresses[networkID].TokenVesting_EDE,
      TokenVestingABI,
      signer
    );
    const claimable_aEDE = await TokenVestingContract_EDE.pendingPayoutFor(
      address || PLACEHOLDER_ACCOUNT
    );
    const vestingInfo_aEDE = await TokenVestingContract_EDE.vestingInfo(
      address || PLACEHOLDER_ACCOUNT
    );
    const vestingInfo_time1 = vestingInfo_aEDE[1];
    const vestingInfo_time2 = vestingInfo_aEDE[2];
    const currentVestingDuration =
      await TokenVestingContract_EDE.currentVestingDuration(
        address || PLACEHOLDER_ACCOUNT
      );
    const percentVestedRate_aEDE =
      await TokenVestingContract_EDE.percentVestedFor(
        address || PLACEHOLDER_ACCOUNT
      );

    return {
      pending_aEDE: ethers.utils.formatEther(vestingInfo_aEDE[0]),
      percentVestedRate_aEDE: ethers.utils.formatUnits(
        percentVestedRate_aEDE,
        7
      ),
      claimable_aEDE: ethers.utils.formatEther(claimable_aEDE),
      vestingInfo_time1,
      vestingInfo_time2,
      currentVestingDuration,
    };
  }
);

const initialState = {
  loading: false,
};

const vestingSlice = createSlice({
  name: "vesting",
  initialState,
  reducers: {
    fetchVestingSuccess(state, action) {
      setAll(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadVestingDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadVestingDetails.fulfilled, (state, action) => {
        setAll(state, action.payload);
        state.loading = false;
      })
      .addCase(loadVestingDetails.rejected, (state, {}) => {
        state.loading = false;
      });
  },
});

const baseInfo = (state: RootState) => state.vesting;
export default vestingSlice.reducer;
export const { fetchVestingSuccess } = vestingSlice.actions;
export const getVestingState = createSelector(baseInfo, (vesting) => vesting);
